import React from "react";
import Accordion from "react-bootstrap/Accordion";
import parse from "html-react-parser";
import { HelpCircle } from "lucide-react";

interface FaqItem {
  id: number | string;
  faq_question: string;
  faq_answer: string;
}

interface FaqProps {
  faqList: FaqItem[];
  title?: string;
  subtitle?: string;
}

const Faq: React.FC<FaqProps> = ({
  faqList,
  title = "Frequently Asked Questions",
  subtitle = "Everything you need to know about our scope, delivery process, and SLAs.",
}) => {
  if (!Array.isArray(faqList) || faqList.length === 0) {
    return null;
  }

  const defaultKey = faqList[0]?.id ? String(faqList[0].id) : undefined;

  return (
    <section className="cht-py-14 sm:cht-py-20 cht-bg-[#f8fafc]/60">
      <div className="cht-max-w-4xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
        <header className="cht-text-center cht-mb-10 sm:cht-mb-14">
          <div className="cht-inline-flex cht-items-center cht-gap-2 cht-px-3.5 cht-py-1.5 cht-bg-blue-50 cht-border cht-border-blue-100 cht-rounded-full cht-text-xs !cht-font-bold cht-text-[#3e57da] cht-mb-4">
            <HelpCircle size={14} />
            <span>Got Questions?</span>
          </div>

          <h2 className="!cht-font-heading cht-text-2xl sm:cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b] cht-tracking-tight cht-mb-3">
            {title}
          </h2>

          {subtitle && (
            <p className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-600 cht-leading-relaxed">
              {subtitle}
            </p>
          )}
        </header>

        <Accordion defaultActiveKey={defaultKey} className="cht-space-y-3.5">
          {faqList.map((item) => (
            <Accordion.Item
              eventKey={String(item.id)}
              key={item.id}
              className="cht-rounded-[18px] cht-border cht-border-slate-200/80 cht-shadow-soft cht-overflow-hidden cht-bg-white !cht-mb-3.5 !cht-border-b"
            >
              <Accordion.Header className="!cht-font-heading !cht-font-bold !cht-text-slate-900 cht-bg-white">
                <span className="!cht-font-bold cht-text-slate-900 cht-text-sm sm:cht-text-base">
                  {item.faq_question}
                </span>
              </Accordion.Header>
              <Accordion.Body className="!cht-font-body cht-text-sm sm:cht-text-base cht-text-slate-600 cht-leading-relaxed cht-pt-1 cht-pb-5 cht-px-5 cht-bg-white">
                {parse(`${item.faq_answer}`)}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;

